const fields = 'fields[]=*&fields[]=author.*&fields[]=tags.ussoftware_posts_tags_id.*&fields[]=sections.*';
const meta = 'meta=*';
const sort = 'sort[]=sort&sort[]=-publish_at';

export const POSTS_PAGE_SIZE = 6;
export const POSTS_RELATED_LIMIT = 3;

export const CMS_ALL_POSTS_ENDPOINT = (limit: number, params: string) => {
  return `/ussoftware_posts?${fields}&${meta}&${sort}&limit=${limit}&${params}`;
};

export const CMS_ONE_POST_ENDPOINT = (id: string): string => `/ussoftware_posts/${id}?${fields}`;

export const CMS_RELATED_TAGS_ENDPOINT = (tagIds: string[]): string => {
  return `/ussoftware_posts_ussoftware_posts_tags?filter[ussoftware_posts_tags_id][_in]=${tagIds.join(
    ',',
  )}&limit=${POSTS_RELATED_LIMIT}`;
};
